import React from 'react';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: {
    x: 15,
    y: 165,
    fontSize: 9,
  },
};
export function EXPLabel() {
  const { cardProvider } = useUserCardProvider();
  const { x = 25, y = 130, fontSize = 16 } = MAPPING[cardProvider] || {};
  return (
    <g>
      <text fill="#191919" fontWeight="500" fontSize={fontSize} x={x} y={y}>
        EXP
      </text>
    </g>
  );
}

export default EXPLabel;
